<script setup lang="ts">
defineEmits<{
  (e: 'update:modelValue', value: string): void
  (e: 'blur', event: FocusEvent): void
  (e: 'focus', event: FocusEvent): void
}>()

withDefaults(
  defineProps<{
    modelValue?: string
    label: string
    placeholder?: string
    name: string
    disabled?: boolean
    required?: boolean
    error?: string
    charCount?: string
  }>(),
  {}
)
</script>

<template>
  <label class="block border-0">
    <span v-if="label" class="mb-1 text-sm font-medium text-gray-600">
      {{ label }} {{ !required ? `(${$t('forms.optional')})` : '' }}
    </span>

    <textarea
      class="mt-1 block w-full rounded-md border-gray-300 shadow-sm transition focus:ring focus:ring-primary-normal focus:ring-opacity-50"
      rows="3"
      :placeholder="placeholder"
      :value="modelValue"
      @blur="$emit('blur', $event)"
      @focus="$emit('focus', $event)"
      @input="$emit('update:modelValue', ($event.target as HTMLTextAreaElement).value)"
    />

    <div class="flex flex-col">
      <span v-if="charCount" class="mt-2 text-xs font-bold capitalize text-gray-400">
        {{ charCount }}
      </span>
      <ErrorMessage v-if="error" :error="error" class="mt-1" />
    </div>
  </label>
</template>
